var mapStyles = require('./mapStyles');

var maps = {

	apiKey: WP.gmaps_api_key,
	debug: false,
	allMaps: [],
	initialised: false,
	requestedAPI: false,
	gotAPI: false,

	addMaps: function() {
		var self = this;
		
		$('.js-map').each(function () {
			var $map = $(this);

			// Check if the map has a single location set via data attributes
			var singleLocation = $map.data('lat') && $map.data('long') && $map.data('name');

			// If single location exists, use it; otherwise, use all locations from WP.map_locations
			var locations = singleLocation ? [{
				lat: parseFloat($map.data('lat')),
				lng: parseFloat($map.data('long')),
				location_name: $map.data('name'),
				view_store_details_link: $map.data('page-link'),
				zoom: $map.data('zoom') || 16
			}] : JSON.parse(WP.map_locations);

			var options = {
				image: {
					url: WP.template_path + '/images/clarity-logo-pin-rounded.png',
					width: 55,
					height: 67
				},
				autoSizeMap: true
			};

			self.createMap($map, locations, options, function(map) {
				// map is now loaded
			});
		});
	},

	loadAPI: function() {
		var self = this;
		self.requestedAPI = true;
		var jsFile = document.createElement('script');
		jsFile.src = 'https://maps.googleapis.com/maps/api/js?callback=clickyCreateMaps&key=' + self.apiKey;
		document.getElementsByTagName('head')[0].appendChild(jsFile);
	},

	createMap: function(el, locations, options, callback) {
		var self = this;

		// if we don't have the API yet, add the map to the
		// allMaps array, otherwise initialise the map
		if (!self.gotAPI) {
			
			self.addMap(el, locations, options, callback);

		} else {

			var _instances = [];

			// set some default options
			var defaults = {
				center: {
					lat: locations[0].lat,
					lng: locations[0].lng
				},
				zoom: locations[0].zoom || 13,
				image: false,
				mapStyles: mapStyles,
				scrollwheel: false,
				mapTypeId: google.maps.MapTypeId.ROADMAP
			};

			// merge the given options with the defaults
			var settings = $.extend({}, defaults, options);

			// create an API friendly options object
			var mapOptions = {
				center: new google.maps.LatLng(settings.center.lat, settings.center.lng),
				zoom: settings.zoom,
				scrollWheel: settings.scrollWheel,
				mapTypeId: settings.mapTypeId,
				styles: settings.mapStyles
			};

			// Create map for each container element
			el.each(function(i, el) {

				// initialise map and infowindow popup
				var map = new google.maps.Map(el, mapOptions);
				var infoWindow = new google.maps.InfoWindow();
				var markerBounds = new google.maps.LatLngBounds();

				// create a property to store all of the markers for the map
				map.allMarkers = [];

				// Batch create all markers for the locations
				locations.forEach(function (currentLocation) {
					var markerPosition = new google.maps.LatLng(currentLocation.lat, currentLocation.lng);

					// define the marker options
					var markerOptions = {
						position: markerPosition,
						map: map,
						animation: google.maps.Animation.DROP
					};

					// add a custom pin icon if one is defined in the map settings
					if (settings.image) {
                        var image = {
                            url: settings.image.url,
                            size: new google.maps.Size(settings.image.width, settings.image.height),
                            scaledSize: new google.maps.Size(settings.image.width, settings.image.height)
                        };
                        markerOptions.icon = image;
                    }

					// initialise the marker
					var marker = new google.maps.Marker(markerOptions);

					// store it in the array within the map instance
					map.allMarkers.push(marker);

					// open the popup window on click
					(function (marker, currentLocation) {
						google.maps.event.addListener(marker, 'click', function (e) {
							// Check if location has a name and show it
							var locationName = currentLocation.location_name || 'Unknown Location';
							var pageLink = currentLocation.view_store_details_link || '#';
							infoWindow.setContent(`<div class="map-info-window"><a href="${pageLink}" class="u-text-base">${locationName}</a></div>`);
							infoWindow.open(map, marker);
						});
					})(marker, currentLocation);

					if(settings.autoSizeMap == true) {
						markerBounds.extend(markerPosition);
					}
				});

				// Fit the bounds of the map after all markers are created
				if (settings.autoSizeMap == true && locations.length > 1) {
					map.fitBounds(markerBounds);
				}

				// re-center map on window resize
				google.maps.event.addDomListener(window, "resize orientationchange", function() {
					var center = map.getCenter();
					google.maps.event.trigger(map, "resize");
					map.setCenter(center);
				});

				self.debugInfo('Map created', map);

				_instances.push(map);
			});

			var result = _instances;

			if (result.length == 1) {
				result = _instances[0];
			}

			callback(result);

			return result;
		}
	},

	addMap: function(el, locations, options, callback) {
		var self = this;

		// make sure the container argument is a jquery object
		if (!(el instanceof jQuery)) {
			el = $(el);
		}
	
		// if there is more than one container on the page
		if (el.length > 0) {

			// push a new map config into the allMaps array
			self.allMaps.push({
				el: el,
				locations: locations,
				options: options,
				callback: callback
			});

			// if we haven't requested the API yet but we've already done the
			// inital setup, create the callback function and get the API
			if (!self.requestedAPI && self.initialised) {
				self.debugInfo('New map initialised');
				self.createCallback();
				self.loadAPI();
			}
		}
	},

	createCallback: function() {
		var self = this;

		window.clickyCreateMaps = function() {
			self.debugInfo('API loaded');
			self.gotAPI = true;

			// loop through all maps initialised so far and create the map
			$.each(self.allMaps, function(i, _map) {
				self.createMap(_map.el, _map.locations, _map.options, _map.callback);
			});
			
			// Dispatch an event that maps API is loaded - for the store finder
			var mapsLoadedEvent = new Event('mapsApiLoaded');
			window.dispatchEvent(mapsLoadedEvent);
		};
		self.debugInfo('Callback function created');
	},

	debugInfo: function() {
		var self = this;
		if (self.debug) {
			console.log.apply(null, arguments);
		}
	},

	init: function() {
		var self = this;

		// add initial maps to the allMaps array
		self.addMaps();
		self.initialised = true;
		var plural = self.allMaps.length == 1 ? '' : 's';
		self.debugInfo(self.allMaps.length + ' map' + plural + ' initialised');

		// if we have maps and haven't requested the API yet, create
		// the callback function and get the API
		if (self.allMaps.length > 0 && !self.requestedAPI) {
			self.createCallback();
			self.debugInfo('API requested');
			self.loadAPI();
		}
	}

};

module.exports = maps;
